/* @flow */

import { Formik, Form } from 'formik';
import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from 'src/shared/app/signup/component/profile/base/BaseSignupProfile.style';
import messages from 'src/shared/app/signup/l10n/aboutSignupL10n';
import withFeatureDecisions from 'src/shared/app/feature/component/withFeatureDecisions';
import UserBaseFieldset from 'src/shared/components/domain/user/form/UserBaseFieldset';
import SecondaryButton from 'src/shared/ui/component/button/SecondaryButton';
import InstructionText from 'src/shared/ui/component/text/InstructionText';

type Props = {
  firstName: string,
  lastName: string,
  i18nFields: Object,
  extraFields: Object,
  schema: Object,
  handleSubmit: (Object) => Promise<any>,
  // $FlowIssue
  intl: intlShape,
};

const useStyles = createUseStyles(styles);

const SignupAboutForm = ({
  firstName,
  lastName,
  i18nFields,
  extraFields,
  schema,
  handleSubmit,
  intl,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <Formik
      initialValues={{
        firstName,
        lastName,
        ...i18nFields,
        ...extraFields,
      }}
      validationSchema={schema}
      validateOnBlur={true}
      onSubmit={(values, { setSubmitting }) =>
        handleSubmit(values).catch(() => {
          setSubmitting(false);
        })
      }
    >
      {({ dirty, isSubmitting }) => (
        <Form className={classes.form} noValidate>
          <div className={classes.legend}>
            <InstructionText>
              {intl.formatMessage(messages.legend)}
            </InstructionText>
          </div>
          <UserBaseFieldset includeSignupExtraFields={true} />
          <div className={classes.btnContainer}>
            <SecondaryButton
              layoutClass={classes.submitBtn}
              isDisabled={!dirty}
              isSubmitting={isSubmitting}
            >
              {intl.formatMessage(messages.submit)}
            </SecondaryButton>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default compose(
  React.memo,
  injectIntl,
  withFeatureDecisions,
)(SignupAboutForm);
